import { SCREEN } from "helper/roleChecker/Screens";

export const getListBirthdayUrl = (screenCode: SCREEN) =>
  `portal-news/birthday/${screenCode}`;

export const getBirthdaysInMonthUrl = (
  screenCode: SCREEN,
  month: string | number,
  year: string | number
) => `portal-news/birthday/${screenCode}/${month}/${year}`;
